import { useCallback, useState } from "react";
import {
  startDocumentIndexingRefresh,
  type BatchJob,
  type DocumentIndexingRefreshMode,
} from "../../../../../lib/corpusApi";
import type { BatchJobParamsForm } from "../../batch_job_kind_contract";

export interface UseDocumentIndexingRefreshParamsResult extends BatchJobParamsForm {
  mode: DocumentIndexingRefreshMode;
  setMode: (mode: DocumentIndexingRefreshMode) => void;
}

/** The one param a document_indexing_refresh job is started with: whether it covers only the
 *  documents without field tags or every document. It always has a value, so the job can always
 *  be started. */
export function useDocumentIndexingRefreshParams(): UseDocumentIndexingRefreshParamsResult {
  const [mode, setMode] = useState<DocumentIndexingRefreshMode>("untagged");

  const start = useCallback(
    (name?: string): Promise<BatchJob> => startDocumentIndexingRefresh({ mode, name }),
    [mode]
  );

  return { mode, setMode, canStart: true, start };
}
